module.exports = __webpack_public_path__ + "media/images/forms-icons/radio-icon-48fe8ecdadb5f402623105d3f3a645a4.svg";